// extracted by mini-css-extract-plugin
module.exports = {"hr":"CustomHR_hr__pZDKB"};
module.exports.__checksum = "6e95c1d59c33"
